import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { PagePaths } from "@/admin/shared/constants";
import { Header, Layout, Sidebar } from "@/admin/widgets";
import {
  DashboardPage,
  NotFoundPage,
  UsersPage,
  OrganizationsPage,
  PlatformsPage,
  DocumentsPage,
  ContentsPage,
  StreamsPage,
  StreamEntrypointsPage,
  CollectionTypesPage,
  MigrationsPage,
  QueuesPage,
  QueueJobsPage,
  MailerConfigsPage,
  ConfigsPage,
  LanguagesPage,
  TranslationsPage,
  TranslationEditorPage,
  PaymentsPage,
  RefundsPage,
  DisputesPage,
  ProductPurchasesPage,
  SubscriptionsPage,
  BillingContractsPage,
  BillingPaymentsPage,
  BillingReportsPage,
  BillingSellerPage,
  AssistantConversationsPage,
  AssistantRequestsPage,
  AssistantPlansPage,
  AssistantUsagePage,
  BillingExpensesPage,
} from "@/admin/pages";

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Standalone-domain deploy (admin.ottkit.io): the bare domain root
            is "/", not PagePaths.admin ("/admin") — that prefix only
            applies to the combined admin+partner build (local dev).
            Without this, visiting the domain root hits the catch-all "*"
            below and renders NotFoundPage instead of the dashboard. */}
        <Route path="/" element={<Navigate to={PagePaths.admin} replace />} />
        <Route element={<Layout header={Header} sidebar={Sidebar} />}>
          <Route index path={PagePaths.admin} element={<DashboardPage />} />
          <Route path={PagePaths.users} element={<UsersPage />} />
          <Route
            path={PagePaths.organizations}
            element={<OrganizationsPage />}
          />
          <Route path={PagePaths.platforms} element={<PlatformsPage />} />
          <Route path={PagePaths.documents} element={<DocumentsPage />} />
          <Route path={PagePaths.contents} element={<ContentsPage />} />
          <Route path={PagePaths.streams} element={<StreamsPage />} />
          <Route
            path={PagePaths.streamEntrypoints}
            element={<StreamEntrypointsPage />}
          />
          <Route
            path={PagePaths.collectionTypes}
            element={<CollectionTypesPage />}
          />
          <Route
            path={PagePaths.mailerConfigs}
            element={<MailerConfigsPage />}
          />
          <Route path={PagePaths.configs} element={<ConfigsPage />} />
          <Route path={PagePaths.languages} element={<LanguagesPage />} />
          <Route
            path={`${PagePaths.translations}/:id/:languageCode`}
            element={<TranslationEditorPage />}
          />
          <Route path={PagePaths.translations} element={<TranslationsPage />} />
          <Route path={PagePaths.migrations} element={<MigrationsPage />} />
          {/* Список задач очереди в конкретном статусе — сюда ведут счётчики
              на карточке очереди; объявлен до самого реестра очередей */}
          <Route
            path={`${PagePaths.queues}/:queueName/:status`}
            element={<QueueJobsPage />}
          />
          <Route path={PagePaths.queues} element={<QueuesPage />} />
          <Route path={PagePaths.payments} element={<PaymentsPage />} />
          <Route path={PagePaths.refunds} element={<RefundsPage />} />
          <Route path={PagePaths.disputes} element={<DisputesPage />} />
          <Route
            path={PagePaths.productPurchases}
            element={<ProductPurchasesPage />}
          />
          <Route
            path={PagePaths.subscriptions}
            element={<SubscriptionsPage />}
          />
          <Route
            path={PagePaths.billingContracts}
            element={<BillingContractsPage />}
          />
          <Route
            path={PagePaths.billingPayments}
            element={<BillingPaymentsPage />}
          />
          <Route
            path={PagePaths.billingReports}
            element={<BillingReportsPage />}
          />
          <Route
            path={PagePaths.billingSeller}
            element={<BillingSellerPage />}
          />
          <Route
            path={PagePaths.assistantConversations}
            element={<AssistantConversationsPage />}
          />
          <Route
            path={PagePaths.assistantRequests}
            element={<AssistantRequestsPage />}
          />
          <Route
            path={PagePaths.assistantPlans}
            element={<AssistantPlansPage />}
          />
          <Route
            path={PagePaths.assistantUsage}
            element={<AssistantUsagePage />}
          />
          <Route
            path={PagePaths.billingExpenses}
            element={<BillingExpensesPage />}
          />
          <Route path={"*"} element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
